import { create } from 'zustand';

export type Filters = {
  search: string;
  team: string;
  assignee: string;
  status: string;
  priority: string;
  // SP→PT-Faktor: keine Filterung, aber zentraler Schätz-Multiplikator
  spToPtFactor: number;
};

type FilterStore = Filters & {
  set: (patch: Partial<Filters>) => void;
  reset: () => void;
  hasAnyFilter: () => boolean;
};

const EMPTY: Filters = {
  search: '',
  team: '',
  assignee: '',
  status: '',
  priority: '',
  spToPtFactor: 1.0,
};

export const useFilters = create<FilterStore>((set, get) => ({
  ...EMPTY,
  set: (patch) => set(patch),
  reset: () => set({ ...EMPTY, spToPtFactor: get().spToPtFactor }),
  hasAnyFilter: () => {
    const s = get();
    return Boolean(s.search || s.team || s.assignee || s.status || s.priority);
  },
}));
